import { render, staticRenderFns } from "./CandidateForm.vue?vue&type=template&id=82a2dc26&scoped=true"
import script from "./CandidateForm.vue?vue&type=script&lang=js"
export * from "./CandidateForm.vue?vue&type=script&lang=js"
import style0 from "./CandidateForm.vue?vue&type=style&index=0&id=82a2dc26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82a2dc26",
  null
  
)

export default component.exports